import script from "./Customer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Customer.vue?vue&type=script&setup=true&lang=ts"

import "./Customer.vue?vue&type=style&index=0&id=7a7f89e2&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a7f89e2"]])

export default __exports__